import { createSelector } from 'reselect';

const selectRoleTemplatesDomain = state => state.RoleTemplates;

// Basic selectors
const makeSelectRoleTemplates = () =>
  createSelector(selectRoleTemplatesDomain, substate => substate);

const makeSelectRoleTemplatesList = () =>
  createSelector(selectRoleTemplatesDomain, substate => substate.roleTemplates);

const makeSelectRoleTemplatesLoading = () =>
  createSelector(selectRoleTemplatesDomain, substate => substate.loading);

const makeSelectRoleTemplatesError = () =>
  createSelector(selectRoleTemplatesDomain, substate => substate.error);

const makeSelectRoleTemplatesLastUpdated = () =>
  createSelector(selectRoleTemplatesDomain, substate => substate.lastUpdated);

// Utility selectors
const makeSelectRoleTemplateById = (templateId) =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => substate.roleTemplates.find(template => template.id === templateId)
  );

const makeSelectRoleTemplatesByCategory = (category) =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => substate.roleTemplates.filter(template => template.category === category)
  );

const makeSelectRoleTemplatesByScope = (scopeId) =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => substate.roleTemplates.filter(template =>
      template.scopes && template.scopes.some(scope => scope.id === scopeId)
    )
  );

const makeSelectRoleTemplatesSearch = (searchTerm) =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => {
      if (!searchTerm) return substate.roleTemplates;
      const term = searchTerm.toLowerCase();
      return substate.roleTemplates.filter(template =>
        template.name.toLowerCase().includes(term) ||
        template.description.toLowerCase().includes(term) ||
        (template.category && template.category.toLowerCase().includes(term))
      );
    }
  );

const makeSelectRoleTemplatesGroupedByCategory = () =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => {
      const grouped = {};
      substate.roleTemplates.forEach(template => {
        const category = template.category || 'Uncategorized';
        if (!grouped[category]) {
          grouped[category] = [];
        }
        grouped[category].push(template);
      });
      return grouped;
    }
  );

const makeSelectRoleTemplatesWithScopeCount = () =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => substate.roleTemplates.map(template => ({
      ...template,
      scopeCount: template.scopes ? template.scopes.length : 0
    }))
  );

const makeSelectRoleTemplatesByScopeCount = (minCount, maxCount) =>
  createSelector(
    selectRoleTemplatesDomain,
    substate => substate.roleTemplates.filter(template => {
      const scopeCount = template.scopes ? template.scopes.length : 0;
      return scopeCount >= minCount && (maxCount === undefined || scopeCount <= maxCount);
    })
  );

export default makeSelectRoleTemplates;
export {
  makeSelectRoleTemplates,
  makeSelectRoleTemplatesList,
  makeSelectRoleTemplatesLoading,
  makeSelectRoleTemplatesError,
  makeSelectRoleTemplatesLastUpdated,
  makeSelectRoleTemplateById,
  makeSelectRoleTemplatesByCategory,
  makeSelectRoleTemplatesByScope,
  makeSelectRoleTemplatesSearch,
  makeSelectRoleTemplatesGroupedByCategory,
  makeSelectRoleTemplatesWithScopeCount,
  makeSelectRoleTemplatesByScopeCount,
};
